export interface LoadDomFill2ContainerOptions {
  path: string
  containerId: string
  callback?: () => void
}

export interface LoadDomFill2ContainerResult {
  componentId: string
  dataAttr: string
}

function getScriptBasePath(): string {
  let currentScript: HTMLScriptElement | null = null
  
  if (document.currentScript) {
    currentScript = document.currentScript as HTMLScriptElement
  } else {
    const scripts = document.getElementsByTagName('script')
    for (let i = scripts.length - 1; i >= 0; i--) {
      const script = scripts[i] as HTMLScriptElement
      // 查找包含公共资源库的脚本，无论它来自哪个域名
      if (script.src && (script.src.includes('public-resource-library') || script.src.includes('Public_Resource_Library') || script.src.includes('public_resource_library_release'))) {
        currentScript = script
        break
      }
    }
    
    // 如果没有找到包含公共资源库的脚本，则使用最后一个脚本
    if (!currentScript) {
      const scripts = document.getElementsByTagName('script')
      if (scripts.length > 0) {
        currentScript = scripts[scripts.length - 1] as HTMLScriptElement
      }
    }
  }
  
  if (!currentScript || !currentScript.src) {
    // 如果无法通过脚本标签找到路径，尝试从全局对象推断
    // 检查是否存在PublicResourceLibrary全局对象
    if (typeof window !== 'undefined' && (window as any).PublicResourceLibrary) {
      // 尝试从已知的CDN地址推断基础路径
      // 常见的CDN地址格式：https://hud.shuchk.com/public_resource_library_release/public-resource-library.umd.js
      const cdnBaseUrl = 'https://hud.shuchk.com/public_resource_library_release/';
      return cdnBaseUrl;
    }
    return '';
  }

  const scriptUrl = new URL(currentScript.src)
  const origin = scriptUrl.origin; // 获取协议和域名
  const pathname = scriptUrl.pathname
  
  const lastSlashIndex = pathname.lastIndexOf('/')
  if (lastSlashIndex === -1) {
    return origin + '/'
  }
  
  // 返回完整的URL路径，包括协议和域名
  return origin + pathname.substring(0, lastSlashIndex + 1)
}

export function loadDomFill2Container(
  path: string,
  containerId: string,
  callback?: () => void
): LoadDomFill2ContainerResult {
  const componentId = Date.now() + '-' + Math.floor(Math.random() * 1000)
  const dataAttr = 'data-' + componentId

  // 首先尝试使用用户传入的path
  const fullPath = path

  console.log('1[loadDomFill2Container] Template path:', path)
  console.log('2[loadDomFill2Container] Full URL:', fullPath)

  // 从环境变量中读取CDN基础URL
  const cdnBaseUrl = (import.meta as any).env?.VITE_CDN_BASE_URL || 'https://hud.shuchk.com/public_resource_library_release/';

  // 首先尝试加载用户传入的path
  fetch(fullPath)
    .then(response => {
      if (!response.ok) {
        // 如果加载失败，尝试从CDN加载
        console.log('3[loadDomFill2Container] Failed to load from local path, trying CDN...')
        console.log('4[loadDomFill2Container] CDN Base URL:', cdnBaseUrl)
        const cdnFullPath = cdnBaseUrl + path.replace(/^\//, '')
        console.log('5[loadDomFill2Container] CDN Full URL:', cdnFullPath)
        return fetch(cdnFullPath)
      }
      return response
    })
    .then(response => response.text())
    .then(html => {
      const parser = new DOMParser()
      const doc = parser.parseFromString(html, 'text/html')

      const allElements = doc.querySelectorAll('*')
      allElements.forEach(element => {
        element.setAttribute(dataAttr, '')
      })

      const styleSheets = doc.querySelectorAll('style')
      styleSheets.forEach(styleSheet => {
        if (styleSheet.textContent) {
          styleSheet.textContent = addComponentSelector(styleSheet.textContent, componentId, dataAttr)
        }
      })

      const linkStyles = doc.querySelectorAll('link[rel="stylesheet"]')
      linkStyles.forEach(link => {
        link.remove()
      })

      const container = document.getElementById(containerId)
      if (!container) {
        console.error(`Container with id "${containerId}" not found`)
        return
      }

      container.innerHTML = ''

      const allProcessedStyles = doc.querySelectorAll('style')
      allProcessedStyles.forEach(style => {
        container.appendChild(style)
      })

      while (doc.body.firstChild) {
        container.appendChild(doc.body.firstChild)
      }
      container.setAttribute(dataAttr, '')

      if (callback) {
        callback()
      }
    })
    .catch(error => {
      console.error('Failed to load HTML content:', error)
    })

  return { componentId, dataAttr }
}

function addComponentSelector(cssText: string, componentId: string, dataAttr: string): string {
  if (!cssText) return ''

  const ruleRegex = /(@media[^{}]+\{[^}]*\})|([^{}]+)\s*\{([^}]+)\}/g

  return cssText.replace(ruleRegex, (_match, mediaQuery, selector, declaration) => {
    if (mediaQuery) {
      const innerRuleRegex = /([^{}]+)\s*\{([^}]+)\}/g
      return mediaQuery.replace(innerRuleRegex, (_innerMatch: string, innerSelector: string, innerDeclaration: string) => {
        return processSingleRule(innerSelector, innerDeclaration, componentId, dataAttr)
      })
    }
    return processSingleRule(selector, declaration, componentId, dataAttr)
  })
}

function processSingleRule(selector: string, declaration: string, componentId: string, _dataAttr: string): string {
  const selectors = selector.split(',').map(s => s.trim())

  const processedSelectors = selectors.map(s => {
    if (!s) return ''
    if (s.startsWith('@') || s.includes('@')) return s
    return `${s}[data-${componentId}]`
  }).filter(s => s)

  return `${processedSelectors.join(',\n')} {${declaration}}`
}
